import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IOrderCancelled } from "@/interfaces/order-status.interfaces";
import orderStatusService from "@/services/order-status.service";
import { RequestsProps } from "@/types/requests.types";

export type CancelOrderProps = {
  formData: IOrderCancelled;
} & RequestsProps;

export type UseCancelOrderReturn = {
  create: (props: CancelOrderProps) => Promise<void>;
} & UseLoadingReturn;

const useCancelOrder = (): UseCancelOrderReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<IOrderCancelled>({
    operation: (formData) => orderStatusService.cancel(formData),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useCancelOrder;
